import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'
import { useFileListStore } from '@/stores/FileList.store'
import { repeatOrder } from '@/features//filestore/FileStoreApi'
import InteractionMixin from '@/mixins/InteractionMixin'
import Cookies from 'js-cookie'
import { UPLOAD_COOKIE } from '@/stores/store'

export default {
  mixins: [InteractionMixin],
  computed: {
    ...mapStores(usePrintStoreStore)
  },
  methods: {
    repeatOrder(orderId) {
      const fileListStore = useFileListStore()
      repeatOrder(Cookies.get(UPLOAD_COOKIE), orderId).then((response) => {
        // A PrintStore order repeat gets the original cart from the server
        if (response[0].printType === 'PRINT_STORE') {
          for (const product of response) {
            // TODO: check if product still available
            // TODO: how to deal with custom products??
            this.printStoreStore.addToCart(product)
          }
        }

        fileListStore.getFiles(true)

        const iaToGo = this.rootStore.interactions.find(
          (ia) => ia.destination === 'printOrder'
        )

        this.$modal.hideAll()
        this.startInteraction(iaToGo)
      })
    }
  }
}
